import type { Action } from 'easy-peasy';
import { action } from 'easy-peasy';

export interface HelperModel {
  helpers: Record<string, boolean>;
  showHelper: Action<HelperModel, string>;
  closeHelper: Action<HelperModel, string>;
}

export const helperModel: HelperModel = {
  helpers: {},
  showHelper: action((state, payload) => {
    state.helpers[payload] = true;
  }),
  closeHelper: action((state, payload) => {
    state.helpers[payload] = false;
  }),
};
